<!-- time-caret.component.html!-->
<div class="container-body" [formGroup]="rFormTime">
    <div class="container-time">{{ value | time }}</div>
    <div class="container-caret">
        <div class="container-caret-item" (click)="sumTime()"><i class="fa fa-caret-up"></i></div>
        <div class="container-caret-item" (click)="minusTime()"><i class="fa fa-caret-down"></i></div>
    </div>
    <input class="hidden" [id]="identifier" [(ngModel)]="value" formControlName="timevalidator" ngDefaultControl
           (keydown.enter)="keyEnter($event)">
</div>